// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pndq6MtNnKHlE8L7ZjDO{margin:10px 0}", "",{"version":3,"sources":["webpack://./src/code-studio/components/lessonExtras/lesson-extras.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA","sourcesContent":[".nextButton {\n  margin: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nextButton": "pndq6MtNnKHlE8L7ZjDO"
};
export default ___CSS_LOADER_EXPORT___;
